import axios from 'axios';
import authHeader from './auth-header';
import Config from '../config/index';

class MediaService {
    async uploadFile(formData) {
        const response = await axios.post(Config.apiBasePath + '/uploadMediaFile', formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    ...authHeader()
                }
            });
        return response;
    }

    getAllMedia() {
        return axios.get(Config.apiBasePath + '/getMediaUploads', {
            headers: {
                ...authHeader()
            }
        });
    }

    getOneMedia(id) {
        id = encodeURIComponent(id);
        return axios.get(Config.apiBasePath + '/getOneMedia/' + id, {

            headers: {
                'Content-Type': 'application/json',
                ...authHeader() // Add your authentication headers here if needed
            }

        });
    }

    async deleteMedia(id) {
        return axios.get(Config.apiBasePath + '/deleteMediaFile/' + id, {
            headers: {
                'Content-Type': 'application/json',
                ...authHeader()
            }
        });
    }

    async createAlbum(album) {
        return axios.post(Config.apiBasePath + '/saveAlbum', album, {
            headers: {
                ...authHeader()
            }
        });

    }

    async getAllAlbums() {
        return axios.get(Config.apiBasePath + '/getAllAlbums', {
            headers: {
                ...authHeader()
            }
        });
    }

    async getAlbum(id) {
        id = encodeURIComponent(id);
        return axios.get(Config.apiBasePath + '/getAlbum/' + id, {
            headers: {
                ...authHeader()
            }
        });
    }

    async getMediaIdsForAlbum(album_id) {
        const id = encodeURIComponent(album_id);
        return axios.get(Config.apiBasePath + '/getMediaByAlbumId/' + id, {
            headers: {
                ...authHeader()
            }
        });

    }

    async updateAlbum(album) {
        return axios.post(Config.apiBasePath + '/updateAlbum', album, {
            headers: {
                ...authHeader()
            }
        });

    }

    async getVideoContent() {
        return axios.get(Config.apiBasePath + '/getVideoContents', {
            headers: {
                ...authHeader()
            }
        });
    }

    async updateVideoContent(video) {
        return axios.post(Config.apiBasePath + '/saveVideoContents', video, {
            headers: {
                ...authHeader()
            }
        });

    }

    async deleteVideoContent(videosContent) {
        return axios.post(Config.apiBasePath + '/deleteVideoContent', videosContent, {
            headers: {
                ...authHeader()
            }
        });

    }
}

export default new MediaService();